import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import axios from '../../../utils/axiosConfig';
import FormModalCreateCiudad from '../forms/formModalCreateCiudad';
import BaseModalXXL from '../../modals/baseModalXXL';
import Swal from 'sweetalert2';

const ModalCiudades = ({ bitInserts, bitEdits, bitDeletes }) => {
    const [ciudades, setCiudades] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);

    const [latitud, setLatitud] = useState('');
    const [longitud, setLongitud] = useState('');

    const [agenciaId, setAgenciaId] = useState('');
    const [nombreCiudad, setNombreCiudad] = useState('');

    const [idEdit, setIdEdit] = useState(-1);

    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    const toggleDialog = () => {
        setDialogOpen(o => !o);
        limpiarCampos();
    };

    const filtered = useMemo(() => {
        if (!debouncedTerm) return ciudades;
        return ciudades.filter(item =>
            Object.values(item).some(val =>
                String(val || '')
                    .toLowerCase()
                    .includes(debouncedTerm)
            )
        );
    }, [ciudades, debouncedTerm]);

    const listarCiudades = () => {
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/getciudades',
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (res.data.success) {
                    console.log('Ciudades cargadas:', res.data.data);
                    setCiudades(res.data.data.recordset);
                } else
                    Swal.fire(
                        'Error',
                        'No se pudo cargar ciudades',
                        'error'
                    );
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'Falla de red al cargar lista',
                    'error'
                )
            );
    };

    const guardarCiudad = ({ nombreCiudad, latitud, longitud, agencyId }) => {
        console.log('Guardando ciudad:', {
            nombreCiudad,
            latitud,
            longitud,
            agencyId,
        });
        const payloadCreate = {
            ID: -1,
            Nombre: nombreCiudad,
            Latitud: latitud,
            Longitud: longitud,
            FKAgencia: agencyId,
        };
        console.log(
            'Payload a subir para crear ciudad:',
            payloadCreate
        );
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/setciudad',
                JSON.stringify(payloadCreate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (res.data.success) {
                    Swal.fire(
                        'Éxito',
                        'Ciudad creada correctamente',
                        'success'
                    );
                    limpiarCampos();
                    listarCiudades();
                    toggleDialog();
                } else {
                    Swal.fire(
                        'Error',
                        'No se pudo crear la ciudad',
                        'error'
                    );
                }
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'Falla de red al crear ciudad',
                    'error'
                )
            );
    };

    const updateCiudad = ({ nombreCiudad, latitud, longitud, agencyId }) => {
        const payloadUpdate = {
            ID: idEdit,
            Nombre: nombreCiudad,
            Latitud: latitud,
            Longitud: longitud,
            FKAgencia: agencyId,
        };
        console.log(
            'Payload a subir para actualizar ciudad:',
            payloadUpdate
        );
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/setciudad',
                JSON.stringify(payloadUpdate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (res.data.success) {
                    Swal.fire(
                        'Éxito',
                        'Ciudad actualizada correctamente',
                        'success'
                    );
                    limpiarCampos();
                    listarCiudades();
                    toggleDialog();
                } else {
                    Swal.fire(
                        'Error',
                        'No se pudo actualizar la ciudad',
                        'error'
                    );
                }
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'Falla de red al actualizar ciudad',
                    'error'
                )
            );
    };

    const handleSave = ({ nombreCiudad, latitud, longitud, agencyId }) => {
        if (idEdit === -1) {
            guardarCiudad({ nombreCiudad, latitud, longitud, agencyId });
        } else {
            updateCiudad({ nombreCiudad, latitud, longitud, agencyId });
        }
    };

    const limpiarCampos = () => {
        setNombreCiudad('');
        setLatitud('');
        setLongitud('');
        setAgenciaId('');
        setIdEdit(-1);
    };

    const editarCiudad = item => {
        console.log('Editando ciudad:', item);
        setNombreCiudad(item.NombreCiudad);
        setLatitud(item.Latitud);
        setLongitud(item.Longitud);
        setAgenciaId(item.FKAgencia);
        setIdEdit(item.IDCiudad);
        setDialogOpen(true);
    };

    const borrarCiudad = item => {
        console.log('Borrando ciudad:', item);
    };

    useEffect(() => {
        const handler = setTimeout(
            () => setDebouncedTerm(searchTerm.trim().toLowerCase()),
            300
        );
        return () => clearTimeout(handler);
    }, [searchTerm]);

    useEffect(() => {
        console.log('Cargando ciudades');
        listarCiudades();
    }, []);

    return (
        <>
            {/* Estilos responsivos solo para este componente */}
            <style>
                {`
                    @media (max-width: 575.98px) {
                        .btn-nueva-ciudad {
                            width: 100%;
                        }
                    }
                `}
            </style>

            <Row className="mb-4 align-items-center">
                <Col sm="6">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar ciudad..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col
                    sm="6"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue btn-nueva-ciudad"
                        onClick={() => {
                            if (bitInserts) toggleDialog();
                        }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nueva Ciudad
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '40%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Nombre Ciudad
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '20%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Latitud
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '20%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Longitud
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '20%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered?.map((item, i) => (
                                <tr key={i}>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'start',
                                        }}
                                    >
                                        {item.NombreCiudad || '-'}
                                    </td>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.Latitud}
                                    </td>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.Longitud}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                if (bitEdits)
                                                    editarCiudad(item);
                                            }}
                                        >
                                            <i
                                                className="bx bxs-pencil bx-tada"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <BaseModalXXL
                isOpen={dialogOpen}
                title={
                    idEdit === -1
                        ? 'Crear ciudad'
                        : 'Editar ciudad'
                }
                onClose={toggleDialog}
            >
                <FormModalCreateCiudad
                    onSave={handleSave}
                    initialData={{
                        nombreCiudad,
                        latitud,
                        longitud,
                        agenciaId,
                    }}
                />
            </BaseModalXXL>
        </>
    );
};

export default ModalCiudades;
